export enum MarketplaceSettings {
	SP_SALES_CHANNEL_SELECTION_ENABLED = 'spSalesChannelSelectionEnabled',
	CROSS_MARKETPLACE_PRODUCT_EDITING_ENABLED = 'crossMarketplaceProductEditingEnabled',
	CROSS_MARKETPLACE_PRODUCT_EDITING_PROTECTED = 'crossMarketplaceProductEditingProtected',
}

export function marketplaceSettingEnabled(client: any, setting: MarketplaceSettings): boolean {
	return client?.fields?.marketplaceSettings?.de
		?.some(candidate => candidate?.id === setting && candidate?.enabled === true) === true
}

// These settings affect authorization and must only be changed through trusted configuration,
// not through the operator-facing generic marketplace-settings endpoint.
export const AUTHORIZATION_MARKETPLACE_SETTINGS = new Set<MarketplaceSettings>([
	MarketplaceSettings.CROSS_MARKETPLACE_PRODUCT_EDITING_ENABLED,
	MarketplaceSettings.CROSS_MARKETPLACE_PRODUCT_EDITING_PROTECTED,
])
